import "./HealthHistoryInfoSummary.scss";
import * as React from "react";
import { HealthHistoryInfo } from "./HealthHistoryInfo";
import HealthHistoryInformationItemsList from "../patient-management/HealthHistoryInformationItemsList";
import EditAction from "../commons/components/action/EditAction";

export default function HealthHistoryInfoSummary({
  forMyself,
  healthHistoryInfo,
  editAction,
  showEditHealthHistoryInfoForm,
}: {
  forMyself: boolean;
  healthHistoryInfo?: HealthHistoryInfo;
  editAction: boolean;
  showEditHealthHistoryInfoForm: () => any;
}) {
  return (
    <div className="health-history-info-summary">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{i18n["Page.Portal.HealthHistoryInformation.Title"]}</div>
        {editAction && <EditAction onClick={showEditHealthHistoryInfoForm} />}
      </div>
      <div>
        {editAction ? (
          <HealthHistoryInformationItemsList healthHistoryInfo={healthHistoryInfo} />
        ) : (
          <div className={"h-flex centered action-container"}>
            <button className="button-secondary small" onClick={showEditHealthHistoryInfoForm}>
              {
                i18n[
                  forMyself
                    ? "Page.Portal.HealthHistoryInformation.CompleteInformation.ForMyself.Button"
                    : "Page.Portal.HealthHistoryInformation.CompleteInformation.Button"
                ]
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
